module.exports = __webpack_public_path__ + "static/table3-fcbbe6de237fbb43ba9c1e8142db99ee.jpg";